<!-- 资料详情 -->
<template>
  <div class="DataInfo_wrap">
    <div
      class="data_list_box"
      v-if="pagesList.length>0"
    >
      <div
        class="data_list_item df jc_sb"
        @click="goPreview(item)"
        v-for="(item,index) in pagesList"
        :key="index"
      >
        <div class="left">
          <div class="f14">{{item.fileName}}</div>
          <div class="size">{{item.fileSize}}</div>
        </div>
        <div class="right">
          <img
            v-if="item.fileTwo=='png'||item.fileTwo=='jpg'"
            src="@/assets/images/img.png"
            alt=""
          >
          <img
            v-else-if="item.fileTwo=='xlsx'"
            src="@/assets/images/excel.png"
            alt=""
          >
          <img
            v-else
            src="@/assets/images/pdf.png"
            alt=""
          >

        </div>
      </div>
    </div>
    <div
      v-else
      style="font-size:12px;color: #A9B4CF;text-align: center;width: 100%;padding-top: 20px;"
    >加载中...</div>

    <van-button
      type="primary"
      class="mobileDld"
      :class="AndroidOrIOS=='iOS'?'iosbtn':''"
      @click="downloadBtn"
    >全部下载</van-button>

    <!-- 资料下载弹框 -->
    <DataPopup :dataPopup="dataPopup" />
  </div>
</template>

<script>
import DataPopup from "@/components/DataPopup.vue";
import { pagesDetail, downloadFileApi } from "@/request/api";

import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      dataPopup: false,
      pageId: "",
      pagesList: [],
      loading: false,
      iphoneNum: "",
      fileId: "",
      AndroidOrIOS: "",
    };
  },
  components: {
    DataPopup,
  },
  created() {
    let AndroidOrIOS = this.checkPlatform();
    this.AndroidOrIOS = AndroidOrIOS;

    var url = window.location.href; //获取当前url
    let { pageId } = this.queryURLParams(url);
    this.pageId = pageId;

    if (pageId) {
      this.getList();
    }
  },
  methods: {
    getImgArrayBuffer(url) {
      let _this = this;
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
    // 打包成zip
    filesToRar(arrImages, filename) {
      let _this = this;
      let zip = new JSZip();
      let cache = {};
      let promises = [];
      this.$toast("正在加载压缩文件...");
      for (let item of arrImages) {
        const promise = _this.getImgArrayBuffer(item.fileUrl).then((data) => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.fileName, data, { binary: true }); // 逐个添加文件
          cache[item.fileName] = data;
        });
        promises.push(promise);
      }
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            this.$toast("正在压缩");
            // 生成二进制流
            FileSaver.saveAs(content, filename); // 利用file-saver保存文件 自定义文件名
            this.$toast("压缩完成");
          });
        })
        .catch((res) => {
          this.$toast("文件压缩失败");
        });
    },

    // 下载资料
    downloadMaterials() {
      this.filesToRar(this.pagesList, "download");
    },
    // 下载全部点击事件
    downloadBtn() {
      let iphoneNum = localStorage.getItem("iphoneNum");
      this.iphoneNum = iphoneNum;
      // 如果没有填过就弹框
      if (!this.iphoneNum) {
        this.dataPopup = true;
      } else {
        //判断是安卓还是ios
        if (this.AndroidOrIOS == "iOS") {
          window.location.href = this.downAllUrl + this.pageId;
        } else {
          this.copyAdress();
        }
      }
    },
    // 复制
    copyAdress() {
      var input = document.createElement("input"); // js创建一个input输入框
      input.value = this.downAllUrl + this.pageId; // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input); // 将输入框暂时创建到实例里面
      input.select(); // 选中输入框中的内容
      document.execCommand("Copy"); // 执行复制操作
      document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作

      this.$toast("下载链接已复制到粘贴板，请打开浏览器粘贴链接进行下载");
    },
    // 路由跳转
    goPreview(item) {
      if (item.fileTwo == "mp4") {
        this.$toast("暂时不支持mp4格式预览");
        return;
      }
      if (item.fileTwo == "xlsx") {
        this.$toast("暂时不支持xlsx格式预览");
        return;
      }
      if (item.fileTwo == "png" || item.fileTwo == "jpg") {
        this.$router.push({
          name: "previewImg",
          query: {
            fileUrl: item.fileUrl,
            fileName: item.fileName,
            pageId: this.pageId,
            fileId: item.fileId,
          },
        });
      } else {
        this.$router.push({
          name: "previewPdf",
          query: {
            fileUrl: item.fileUrl,
            fileName: item.fileName,
            pageId: this.pageId,
            fileId: item.fileId,
          },
        });
      }
    },
    async getList() {
      const res = await pagesDetail("pageId=" + this.pageId);
      this.pagesList = res.data.data.files;
    },
  },
};
</script>
<style scoped>
.DataInfo_wrap {
  min-height: 100vh;
  background: #ededed;
}
.DataInfo_wrap .data_list_box {
  padding: 1.5rem 1rem;
}

.data_list_box .data_list_item {
  background-color: #fff;
  width: 14.4125rem;
  min-height: 3.6875rem;
  margin-bottom: 1.25rem;
  padding: 1rem 0.625rem 0;
  border-radius: 0.375rem;
}

.data_list_item .left {
  width: 10.125rem;
}

.left .size {
  color: #b3b3b3;
  line-height: 0.625rem;
  line-height: 1.125rem;
  font-size: 0.65rem;
}

.data_list_item .right {
  width: 2.475rem;
}

.right img {
  width: 100%;
}

.DataInfo_wrap .mobileDld {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  font-weight: 600;
  font-size: 0.9375rem;
}

.DataInfo_wrap .iosbtn {
  bottom: 18px;
}
</style>